import { useState, useEffect } from "react";
import useForm from '../../../../hooks/useForm';
import { FormField, Button } from '@prosolve/common-components-ui'
import SoefiaConfigPromptEditor from "./SoefiaConfigPromptEditor";

export default ({
  soefiaConfig = {},
  isReadOnly,
  onChange
}) => {

  const {
    prompts = []
  } = soefiaConfig;

  const formSchema = {
    requiredFields: ['id', 'title', 'description', 'videoUrl', 'videoTranscript', 'challengeImage', 'challengeUrl', 'challengeContext', 'autoStartRecording'],
    initData: soefiaConfig
  }
  
  const formData = useForm(formSchema)

  let highestPromptId = 0;
  prompts.forEach(({ id }) => {
    const idNum = Number(id);
    if (idNum > highestPromptId) {
      highestPromptId = idNum;
    }
  });

  const startingNewPromptId = highestPromptId + 1;

  const [newPromptId, setPromptId] = useState(startingNewPromptId)

  const initPrompts = prompts.map(qObj => ({ ...qObj }));

  const [editedPrompts, setEditedPrompts] = useState(initPrompts)


  useEffect(() => {
    const changedValues = {
      ...formData.values,
      prompts: editedPrompts
    }

    onChange(changedValues)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values, editedPrompts])

  const addNewPrompt = () => {
    const newEmptyPromptObj = {
      id: newPromptId,
      question: '',
    }
    const updatedPrompts = [...editedPrompts];
    updatedPrompts.push(newEmptyPromptObj)

    setEditedPrompts(updatedPrompts)

    setPromptId(newPromptId + 1)
  }

  const onPromptChanged = (prompt = {}) => {
    const pIndex = editedPrompts.findIndex(({ id }) => id === prompt.id)

    if (pIndex > -1) {
      const pObj = editedPrompts[pIndex];

      const updatedAOObj = { ...pObj, ...prompt};

      const updatedPrompts = [...editedPrompts];
      updatedPrompts[pIndex] = updatedAOObj;

      setEditedPrompts(updatedPrompts)
    }
  }

  const onPromptDeleted = (prompt = {}) => {
    const pIndex = editedPrompts.findIndex(({ id }) => id === prompt.id)
    if (pIndex > -1) {
      const updatedPrompts = [...editedPrompts];
      updatedPrompts.splice(pIndex, 1)
      setEditedPrompts(updatedPrompts)
    }
  }

  return (
    <div style={{
      padding: '20px',
      background: '#ffffff',
      borderBottomLeftRadius: '5px',
      borderBottomRightRadius: '5px',
    }}>
      <div style={{ 
        display: 'flex',
        marginBottom: '10px'
      }}>
        <div 
          style={{
            flex: 1,
            color: '#565656', 
            fontSize: '14px', 
            fontWeight: 'bold',
            marginBottom: '10px'
          }}
        >
          {'Soefia Configuration'}
        </div>
        <Button
          style={{ width: '250px' }}
          $colored={true}
          $disabled={isReadOnly}
          onClick={() => {
            if (!isReadOnly) {
              addNewPrompt()
            }
          }}
        >
          {'Add New Prompt'}
        </Button>
      </div>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '20px',
        marginBottom: '20px'
      }}>
        <FormField
          fieldId='title'
          type='text'
          label='Title'
          disabled={isReadOnly}
          style={{ flex: 1 }}
          formData={formData}
        />
        <FormField
          fieldId='description'
          type='textarea'
          label='Description'
          disabled={isReadOnly}
          style={{ flex: 1 }}
          formData={formData}
        />
        <FormField
          fieldId='videoUrl'
          type='text'
          label='Video Url'
          disabled={isReadOnly}
          style={{ flex: 1 }}
          formData={formData}
        />
        <FormField
          fieldId='videoTranscript'
          type='textarea'
          label='Video Transcript'
          disabled={isReadOnly}
          style={{ flex: 1 }}
          formData={formData}
        />
        <FormField
          fieldId='challengeImage'
          type='text'
          label='Challenge Image'
          disabled={isReadOnly}
          style={{ flex: 1 }}
          formData={formData}
        />
        <FormField
          fieldId='challengeUrl'
          type='text'
          label='Challenge Url'
          disabled={isReadOnly}
          style={{ flex: 1 }}
          formData={formData}
        />
        <FormField
          fieldId='challengeContext'
          type='textarea'
          label='Challenge Context'
          disabled={isReadOnly}
          style={{ flex: 1 }}
          formData={formData}
        />
        <FormField
          fieldId='autoStartRecording'
          type='checkbox'
          label='Auto Start Recording'
          disabled={isReadOnly}
          style={{ flex: 1 }}
          formData={formData}
        />
      </div>
      {
        prompts.map(prompt => {
          return (
            <SoefiaConfigPromptEditor
              key={prompt.id}
              prompt={prompt}
              isReadOnly={isReadOnly}
              onChange={onPromptChanged}
              onDelete={onPromptDeleted}
            />
          )
        })
      }
    </div>
  )
}